export const SERVICES = [
  {
    slug: "masonry-bricklaying",
    anchor: "masonry-bricklaying",
    name: "Masonry & Bricklaying",
    shortName: "Masonry & Bricklaying",
    summary:
      "Structural and veneer masonry for commercial and industrial buildings — brick, block, and stone work built to last, executed by skilled bricklayers.",
    bullets: [
      "Commercial & industrial brick veneer",
      "Structural masonry and block work",
      "Brick facade construction and restoration",
      "Masonry repair and re-pointing",
    ],
    image: "/images/service-masonry.jpg",
    imageAlt:
      "Bricklayer laying a brick veneer wall on a commercial building under construction",
    serviceType: "Masonry Construction",
  },
  {
    slug: "siding-cladding",
    anchor: "siding-cladding",
    name: "Siding & Exterior Cladding",
    shortName: "Siding & Cladding",
    summary:
      "Durable exterior envelope solutions for commercial and industrial properties — metal, vinyl, and fiber-cement siding installed to hold up under real-world conditions.",
    bullets: [
      "Metal, vinyl, and fiber-cement siding",
      "Insulated panel systems",
      "Building envelope and weatherproofing",
      "Exterior cladding replacement and repair",
    ],
    image: "/images/service-siding.jpg",
    imageAlt:
      "Crew installing metal siding panels on the exterior of an industrial building",
    serviceType: "Siding Installation",
  },
  {
    slug: "project-management",
    anchor: "project-management",
    name: "Project Management & Construction Delivery",
    shortName: "Project Management",
    summary:
      "Full-service delivery wrapped around our trade work — pre-construction planning, general contracting, and design-build coordination that keeps commercial and industrial projects on schedule and on budget.",
    bullets: [
      "Pre-construction planning & budgeting",
      "General contracting & site supervision",
      "Design-build coordination",
      "Scheduling and trades coordination through delivery",
    ],
    image: "/images/service-project-management.jpg",
    imageAlt:
      "Construction project manager reviewing blueprints on a commercial job site",
    serviceType: "Construction Project Management",
  },
];

export const getServiceBySlug = (slug) =>
  SERVICES.find((s) => s.slug === slug);
